import React, { forwardRef, MutableRefObject } from 'react';
import { WithTranslationsProps } from 'react-utilities';
import { TGameData } from '../types/bedev1Types';
import { GameTile } from './GameTile';
import { SponsoredGameTile } from './SponsoredGameTile';
import { FeaturedGridTile } from './FeaturedGameTile';
import { TSharedGameTileProps, TOnTileClick } from './GameTileUtils';
import '../../../../css/common/_gameGrid.scss';

export type TGameGridProps = {
  gameData: TGameData[];
  emphasis?: boolean;
  translate: WithTranslationsProps['translate'];
  onTileClick: TOnTileClick;
  tileRef?: MutableRefObject<HTMLDivElement | null>;
};

export const GameGridTile = forwardRef<
  HTMLDivElement,
  {
    emphasis: boolean;
  } & TSharedGameTileProps
>(
  (
    {
      emphasis,
      ...props
    }: {
      emphasis: boolean;
    } & TSharedGameTileProps,
    ref
  ) => {
    if (props.gameData.isSponsored) {
      return <SponsoredGameTile ref={ref} {...props} />;
    }

    if (emphasis) {
      return <FeaturedGridTile ref={ref} {...props} />;
    }

    return <GameTile ref={ref} {...props} />;
  }
);

export const GameGrid = forwardRef<HTMLDivElement, TGameGridProps>(
  ({ gameData, translate, emphasis, onTileClick, tileRef }: TGameGridProps, forwardedRef) => {
    return (
      <div ref={forwardedRef} className='game-grid'>
        {gameData.map((data, positionId) => (
          <GameGridTile
            ref={ref => {
              if (
                ((emphasis === true && positionId === 1) ||
                  (emphasis === false && positionId === 0)) &&
                tileRef
              ) {
                // eslint-disable-next-line no-param-reassign
                tileRef.current = ref;
              }
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={positionId}
            id={positionId}
            gameData={data}
            translate={translate}
            onTileClick={onTileClick}
            emphasis={emphasis === true && positionId === 0}
          />
        ))}
      </div>
    );
  }
);

export default GameGrid;
